<template lang="pug">
  el-row.labelDiv
    el-col.inputDiv(:span="12")
      div(
        v-if="pessoa && pessoa.tipo === 'PF'",
        key="pessoa-fisica"
      )
        app-display(
          label="CPF:",
          :content="pessoa.pessoaFisica.cpf"
        )
        app-display(
          label="RG:",
          :content="pessoa.pessoaFisica.rg",
          v-if="pessoa.pessoaFisica.rg"
        )
        app-display(
          label="Nacionalidade:",
          :content="getGentilico(pessoa.pessoaFisica.nacionalidade)",
          v-if="pessoa.pessoaFisica.nacionalidade"
        )
        app-display(
          label="Naturalidade:",
          :content="getNaturalidade(pessoa.pessoaFisica)",
          v-if="pessoa.pessoaFisica.municipio || pessoa.pessoaFisica.naturalidade"
        )
        app-display(
          label="Profissão:",
          :content="pessoa.pessoaFisica.profissao",
          v-if="pessoa.pessoaFisica.profissao"
        )

      div(
        v-if="pessoa && pessoa.tipo === 'PJ'",
        key="pessoa-juridica"
      )
        app-display(
          label="CNPJ:",
          :content="pessoa.pessoaJuridica.cnpj"
        )
        app-display(
          :label="razaoSocialName",
          :content="pessoa.pessoaJuridica.razaoSocial"
        )
        app-display(
          label="E-mail:",
          :content="pessoa.email",
          v-if="!isConjuge"
        )
        app-display-multiple(
          label="Telefones:",
          :content="pessoa.telefones"
          v-if="pessoa.telefones.length > 0"
        )

    el-col.inputDiv(:span="12")
      div(
        v-if="pessoa && pessoa.tipo === 'PF'",
        key="pessoa-fisica"
      )
        app-display(
          label="Nome:",
          :content="pessoa.pessoaFisica.nome"
        )
        app-display(
          label="Órgão expedidor:",
          :content="getOrgaoExpedidor(pessoa.pessoaFisica.orgaoExpedidor)",
          v-if="pessoa.pessoaFisica.orgaoExpedidor"
        )
        app-display(
          label="Naturalidade:",
          :content="pessoa.pessoaFisica.municipioEstadoNaturalidade",
          v-if="pessoa.pessoaFisica.municipioEstadoNaturalidade"
        )
        app-display(
          label="Nome da Mãe:",
          :content="pessoa.pessoaFisica.nomeDaMae",
          v-if="pessoa.pessoaFisica.nomeDaMae"
        )
        app-display-multiple(
          label="Telefones:",
          :content="pessoa.telefones"
          v-if="pessoa.telefones.length > 0"
        )
        app-display(
          label="Estado civil:",
          :content="estadoCivilFormatado",
          v-if="pessoa.pessoaFisica.estadoCivil"
        )
        app-display(
          label="Data de nascimento:",
          :content="data",
          v-if="data"
        )
        app-display(
          label="E-mail:",
          :content="pessoa.email",
          v-if="!isConjuge"
        )

</template>

<script>

import moment from 'moment'
import AppDisplay from '@/components/AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import gentilicos from '@/constants/gentilico'

export default {

  components: {
    AppDisplay,
    AppDisplayMultiple
  },

  props: {
    pessoa: {
      type: Object,
      required: true
    },
    isConjuge: {
      type: Boolean,
      default: false
    },
    razaoSocialName: {
      type: String,
      default: 'Razão Social'
    }
  },

  computed: {
    data () {
      if (this.pessoa.pessoaFisica.dataNascimento) {
        return moment(this.pessoa.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
      }
    },

    estadoCivilFormatado () {
      switch (this.pessoa.pessoaFisica.estadoCivil) {
        case 'SOLTEIRO':
          return 'Solteiro(a)'
        case 'CASADO':
          return 'Casado(a)'
        case 'DIVORCIADO':
          return 'Divorciado(a)'
        case 'SEPARADO':
          return 'Separado(a)'
        case 'VIUVO':
          return 'Viúvo(a)'
        case 'UNIAO_ESTAVEL':
          return 'União Estável'
        case 'UNIAO_HOMOAFETIVA':
          return 'União Homoafetiva'
      }
    }
  },

  methods: {
    getGentilico (sigla) {
      return gentilicos.filter(item => item.sigla === sigla)[0].gentilico
    },
    getOrgaoExpedidor (orgao) {
      return orgao.nome + (orgao.estado ? ' - ' + orgao.estado : '')
    },
    getNaturalidade (pessoa) {
      if (pessoa.municipio) {
        return pessoa.municipio.nome + ' - ' + pessoa.municipio.estadoCod
      } else {
        return pessoa.naturalidade.nome + ' - ' + pessoa.naturalidade.codigoEstado
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 1vh;
    font-size: 14px;
    b {
      span{
        font-weight: normal !important;
      }
    }
  }

  @media (max-width: 780px) {
    .labelDiv {
      display: flex;
      flex-direction: column;
    }

    .inputDiv {
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/common/InformacoesPessoa.vue